import React from 'react';
import { useLocation } from 'react-router-dom';
import SelectPaymentMethod from './SelectPaymentMethod';
import SubjectSubscriptionPayment from './SubjectSubscriptionPayment';
import AssessmentSubscriptionPayment from './AssessmentSubscriptionPayment';

export default function SubscriptionPaymentPage() {
  const location = useLocation();
  if (location.state?.examPurchase || new URLSearchParams(location.search || '').get('kind') === 'exam') return <AssessmentSubscriptionPayment exam />;
  if (location.state?.subjectCart) return <SubjectSubscriptionPayment />;
  if (location.state?.assessmentPurchase) return <AssessmentSubscriptionPayment />;
  return <SelectPaymentMethod />;
}
